import { Autocomplete, Button, Chip, Input, TextField } from "@mui/material"
import { useState } from "react"

const InviteComponent = ({onSubmit}: {onSubmit: Function}) => {
    const [emails, setEmails] = useState<string[]>([])
    const [input, setInput] = useState<string>('')

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            const trimmed = input.trim();
            if (trimmed == '') {
                onSubmit(emails);
            } 
                
        }
        if (['Enter', ',', ' ', 'Tab'].includes(e.key)) {
            e.preventDefault();
            const trimmed = input.trim();
            if (trimmed) {
                setEmails(prev => [...prev, trimmed]);
                setInput('');
            }
        }
    };
    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInput(e.target.value.toLowerCase().trim())
    };
    return (
        <>
            <TextField
                fullWidth
                label="Enter your emails"
                value={input}
                onChange={handleEmailChange}
                onKeyDown={handleKeyDown}
                variant="outlined"
            />
            <br />
            <br />
            {emails.map((email, index) => (
                <Chip
                    key={email}
                    label={email}
                    onDelete={() => {
                        setEmails((prev) => prev.filter((_, i) => i !== index));
                    }}
                    sx={{ m: 0.5 }}
                />
            ))}
            <br />
            <br />
            <Button
                onClick={() => {
                    console.log(emails);
                    onSubmit(emails);
                    setEmails([]);
                }}
                variant="contained"
                style={{float: "right"}}
            >
                Send
            </Button>
        </>
    )
}

export default InviteComponent